import PageTypeA from "../components/pageTypeA/PageTypeA";
import { pagesDataA } from "../data/pagesData";

const Page10 = () => {
  return (
    <PageTypeA title={pagesDataA[5].title} subtitle={pagesDataA[5].subtitle} image={pagesDataA[5].image}/>
  );
};

export default Page10;
